import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ClSelectButton } from '@corelabs/angular/ui';
import { ErrorComponent } from '../error/error.component';
import { FormOption } from '../form-option.type';

@Component({
    selector: 'app-form-select-button',
    templateUrl: './form-select-button.component.html',
    styleUrls: ['./form-select-button.component.css'],
    imports: [ReactiveFormsModule, ClSelectButton, ErrorComponent],
})
export class FormSelectButtonComponent<T> {
    readonly control = input.required<FormControl<T>>();
    readonly label = input<string>('');
    readonly options = input.required<FormOption<T>[]>();
    readonly inputId = input.required<string>();
}
